/* Modules grouped by activeNavType */
export const MEGA_MENU_REGISTRY = 'MEGA_MENU_REGISTRY';
export const MEGA_MENU_PAPER = 'MEGA_MENU_PAPER';
export const MEGA_MENU_WEBSITE = 'MEGA_MENU_WEBSITE';
export const MEGA_MENU_WEBSITE_LARGE = 'MEGA_MENU_WEBSITE_LARGE';
export const MEGA_MENU_GUEST_LIST = 'MEGA_MENU_GUEST_LIST';
export const MEGA_MENU_BOUTIQUE = 'MEGA_MENU_BOUTIQUE';
export const MEGA_MENU_VENDORS = 'MEGA_MENU_VENDORS';
export const MEGA_MENU_ALBUMS = 'MEGA_MENU_ALBUMS';
export const MEGA_MENU_ALBUMS_LARGE = 'MEGA_MENU_ALBUMS_LARGE';
export const MEGA_MENU_ADVICE = 'MEGA_MENU_ADVICE';

/* Individual Module Titles */
export const ADVICE_GUEST = 'MEGA_MENU_ADVICE_1';
export const CHECKLIST_NOT_ACTIVATED = 'MEGA_MENU_ADVICE_2';
export const CHECKLIST_ACTIVATED = 'MEGA_MENU_ADVICE_3';
